export const host = {
  DEV: "d-dental-portfolio-static.dev.digitaledge.cigna.com",
  QA: "t-dental-portfolio-static.test.digitaledge.cigna.com",
  PROD: "p-dental-portfolio-static.digitaledge.cigna.com",
  LOCAL: "localhost:3000",
  DEV_PROVIDERS_DOT_BRIGHTER_COM: "dev.providers.brighter.com",
  QA_PROVIDERS_DOT_BRIGHTER_COM: "test.providers.brighter.com",
  PROD_LIVE:"providers.brighter.com"
};

export const getbaseURL = () => {
  const devUrl =
  // "https://d-digital2.dev.internal.digitaledge.cigna.com/pbc/dental-app/";
  "https://d-digital2.dev.digitaledge.cigna.com/pbc/dental-app/";
    // "https://d-pbc-reviews-pbc-reviews-dental-provider-portfolio-api.router.digital-eks.digexp-dev.aws.cignacloud.com/";
  const qaUrl =
  //  "https://a-digital2.test.internal.digitaledge.cigna.com/pbc/dental-app/";
  "https://a-digital2.test.digitaledge.cigna.com/pbc/dental-app/";
  //  "https://a-pbc-reviews-pbc-reviews-dental-provider-portfolio-api.router.digital-eks.digexp-test.aws.cignacloud.com/";
  const prodUrl =
  "https://p-digital2.digitaledge.cigna.com/pbc/dental-app/";
    // "https://p-pbc-reviews-pbc-reviews-dental-provider-portfolio-api.router.digital-eks.digexp-prod.aws.cignacloud.com/";
  switch (window.location.host) {
    case host.DEV_PROVIDERS_DOT_BRIGHTER_COM:
    case host.DEV:
      return devUrl;
    case host.LOCAL:
      return devUrl;
      
    case host.QA_PROVIDERS_DOT_BRIGHTER_COM:
    case host.QA:
      return qaUrl;

    case host.PROD:
      return prodUrl;

    case host.PROD_LIVE:
      return prodUrl;
  }
};

export const baseUrl = getbaseURL();
